"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDetailGalleryFloorPlanState = exports.defaultDetailGalleryPhotoState = exports.defaultDetailGalleryState = exports.defaultDetailGalleryItems = void 0;
var DetailGalleryState_1 = require("@/pages/detail/states/DetailGalleryState");
var DetailVideo_init_1 = require("@/pages/detail/states/DetailVideo.init");
exports.defaultDetailGalleryItems = [
    {
        type: DetailGalleryState_1.DetailGalleryItemType.VR,
        thumb: 'https://images.okay.com/DiscoveryBay/DevelopmentThumbnails/Amalfi_1.jpg',
        src: 'https://my.matterportvr.cn/show/?m=nLZNRRdcYKH',
    },
    {
        type: DetailGalleryState_1.DetailGalleryItemType.VIDEO,
        thumb: DetailVideo_init_1.defaultDetailVideo.thumb,
        src: DetailVideo_init_1.defaultDetailVideo.src,
        title: DetailVideo_init_1.defaultDetailVideo.title,
        caption: DetailVideo_init_1.defaultDetailVideo.caption,
    },
    {
        type: DetailGalleryState_1.DetailGalleryItemType.IMAGE,
        thumb: 'https://images.okay.com/Property/HQ/olympian-mansion-mid-levels-west-for-sale-41830_637611772160997398.jpg',
        src: 'https://images.okay.com/Property/HQ/olympian-mansion-mid-levels-west-for-sale-41830_637611772160997398.jpg',
    },
    {
        type: DetailGalleryState_1.DetailGalleryItemType.IMAGE,
        thumb: 'https://images.okay.com/DiscoveryBay/DevelopmentThumbnails/Amalfi_1.jpg',
        src: 'https://images.okay.com/DiscoveryBay/DevelopmentThumbnails/Amalfi_1.jpg',
        caption: 'hi2',
    },
    {
        type: DetailGalleryState_1.DetailGalleryItemType.IMAGE,
        thumb: 'https://images.okay.com/property/wp1800_1200/silver-view-lodge-clearwater-bay-for-sale-285290_637691102908622809.webp',
        src: 'https://images.okay.com/property/wp1800_1200/silver-view-lodge-clearwater-bay-for-sale-285290_637691102908622809.webp',
    },
    {
        type: DetailGalleryState_1.DetailGalleryItemType.IMAGE,
        thumb: 'https://images.okay.com/property/wp1800_1200/silver-view-lodge-clearwater-bay-for-sale-285290_637691102945622931.webp',
        src: 'https://images.okay.com/property/wp1800_1200/silver-view-lodge-clearwater-bay-for-sale-285290_637691102945622931.webp',
    },
    {
        type: DetailGalleryState_1.DetailGalleryItemType.FLOORPLAN,
        thumb: 'https://images.okay.com/property/wp1800_1200/silver-view-lodge-clearwater-bay-for-sale-285290_637695466251253674.webp',
        src: 'https://images.okay.com/property/wp1800_1200/silver-view-lodge-clearwater-bay-for-sale-285290_637695466251253674.webp',
    },
    {
        type: DetailGalleryState_1.DetailGalleryItemType.IMAGE,
        thumb: 'https://images.okay.com/property/wp1800_1200/silver-view-lodge-clearwater-bay-for-sale-285290_637691105551836928.webp',
        src: 'https://images.okay.com/property/wp1800_1200/silver-view-lodge-clearwater-bay-for-sale-285290_637691105551836928.webp',
    },
];
exports.defaultDetailGalleryState = {
    id: 'detail',
    currentIndex: 2,
    items: exports.defaultDetailGalleryItems,
    showMapView: true,
    showStreetView: true,
    showThumbs: true,
    showFloorPlan: true,
    showOverlay: true,
    isSoleAgent: true,
    t: {
        mapView: 'Map View',
        streetView: 'Street View',
        soleAgent: 'Sole Agent',
        video: 'Video',
        virtualTour: 'Virtual Tour',
    },
};
exports.defaultDetailGalleryPhotoState = {
    id: 'detailgallery',
    currentIndex: 0,
    items: exports.defaultDetailGalleryItems.filter(function (it) { return it.type === DetailGalleryState_1.DetailGalleryItemType.IMAGE; }),
    showMapView: false,
    showStreetView: false,
    showThumbs: false,
    showFloorPlan: false,
    showOverlay: false,
    isSoleAgent: false,
    t: exports.defaultDetailGalleryState.t,
};
exports.defaultDetailGalleryFloorPlanState = {
    id: 'detailfloorplan',
    currentIndex: 1,
    items: exports.defaultDetailGalleryItems
        .filter(function (it) { return it.type === DetailGalleryState_1.DetailGalleryItemType.FLOORPLAN; }),
    showMapView: false,
    showStreetView: false,
    showThumbs: false,
    showFloorPlan: false,
    showOverlay: false,
    isSoleAgent: false,
    t: exports.defaultDetailGalleryState.t,
};
